// Mobile nav toggle

var toggleButton  =  document.querySelector(".header-offcanvas-toggle");
var mobileNav     =  document.querySelector(".offcanvas");
var body          =  document.querySelector("body");

if (toggleButton) {
	toggleButton.addEventListener('click', function() {
		mobileNav.classList.toggle("show");
		body.classList.toggle("overflow-hidden");
	}, false);
}